import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ScaleIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3C12.5523 3 13 3.44772 13 4V4.55278L18.4453 5.91421C18.9809 6.04812 19.3066 6.59076 19.1727 7.12632C19.0388 7.66188 18.4961 7.98758 17.9606 7.85367L13 6.61297V18H16C16.5523 18 17 18.4477 17 19C17 19.5523 16.5523 20 16 20H8C7.44772 20 7 19.5523 7 19C7 18.4477 7.44772 18 8 18H11V6.61297L6.03944 7.85367C5.50388 7.98758 4.96124 7.66188 4.82733 7.12632C4.69342 6.59076 5.01912 6.04812 5.55468 5.91421L11 4.55278V4C11 3.44772 11.4477 3 12 3Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M6 8L3 14H9L6 8ZM6 11.236L7.382 14H4.618L6 11.236ZM18 8L15 14H21L18 8ZM18 11.236L19.382 14H16.618L18 11.236Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ScaleIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ScaleIcon);
